export const removeLineBreaks = (input?: string): string | undefined => {
  return input
    ?.replace(/[\r\n]+/g, ' ')
    .replace(/\s+/g, ' ')
    ?.trim()
}

export const extractLastPart = (input: string, separator: string = '/'): string => {
  return input.split(separator).pop() || ''
}

export const camelToWords = (str: string) => {
  return str.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase())
}

export const capitalizeFirstLetter = (str: string) => {
  if (!str) {
    return str
  }

  return str.charAt(0).toUpperCase() + str.slice(1)
}
